export * from "./contact-us";
export * from "./faqs";
export * from "./glossary";
export * from "./hero";
export * from "./industries";
export * from "./legal";
export * from "./metadata";
export * from "./service-areas";
export * from "./services";
export * from "./small-gallery";
export * from "./tags";
